import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import FormLoader from '../FormLoader/FormLoader'
import { format } from 'date-fns'

export default function TermSelectForm({ termList, user, ...props }) {
  const [isLoading] = useState(false)
  const [isEnabled, setIsEnabled] = useState(0)
  const [termValue, setTermValue] = useState(0)

  const handleChange = e => {
    const value = e.target.value
    setTermValue(value)
    setIsEnabled(Number(value))
  }
  const dateFormatter = date => {
    return format(new Date(date), 'M/dd/yyyy')
  }
  const handleSubmit = e => {
    e.preventDefault()
    const noTerm = termValue == 0
    if (noTerm) {
      alert('Please select a term')
    }
    else {
      const val = termList.filter(c => c.id == termValue)[0]
      props.userSelectTerm(val)
    }
  }
  useEffect(() => {}, [termValue])

  return (
    <div className="termForm">
      <form onSubmit={handleSubmit}>
        <article>
          <header>
            <div className="center-text">
              <h1>{user.name}</h1>
              <div>
                <strong>{user.email}</strong>
              </div>
              <small>
                Select the term you would like to process this reimbursement
                with.
              </small>
            </div>
          </header>
          {termList.map(c => {
            return (
              <div id={c.id} key={c.id} className="card mb-5">
                <h3 className="card-title">
                  <strong>{c.title}</strong>
                </h3>
                <div>Start of term: {dateFormatter(c.start_date)}</div>
                <div className="date mb-5">
                  End of term: {dateFormatter(c.end_date)}
                </div>
                <label className="mt-10" htmlFor="terms">
                  <input
                    onChange={handleChange}
                    id={c.id}
                    type="radio"
                    name="term"
                    value={c.id}
                  ></input>
                  Choose Term
                </label>

                <div>
                  <button
                    id="term-select-continue-button"
                    disabled={isEnabled !== c.id}
                    type="submit"
                    className="primary-button mt-5"
                  >
                    {isLoading ? (
                      <FormLoader message={'Loading'} />
                    ) : (
                      'Continue'
                    )}
                  </button>
                </div>
              </div>
            )
          })}
          <footer>60 Day Activity</footer>
        </article>
      </form>
    </div>
  )
}
TermSelectForm.propTypes = {
  termList: PropTypes.func,
  user: PropTypes.func,
  userSelectTerm: PropTypes.func,
}
